module.exports = __webpack_public_path__ + "static/img/concat.3c24233e.png";